/* gemstone-parallax.js — Scroll-reveal & bg parallax for the Gemstone homepage */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ─── Helpers ───────────────────────────────────────────────── */
  function reveal(el, type, delay) {
    if (!el) return;
    el.classList.add('gp-reveal');
    if (type && type !== 'up') el.classList.add('gp-reveal--' + type);
    if (delay) el.style.setProperty('--gp-delay', delay + 'ms');
  }

  function revealAll(els, type, baseDelay, step) {
    Array.prototype.forEach.call(els, function (el, i) {
      reveal(el, type, baseDelay + Math.min(i, 7) * (step || 0));
    });
  }

  /* ─── 1. Tag elements for scroll-reveal ────────────────────── */
  function tag() {
    /* Gemstone Planet */
    document.querySelectorAll('[id^="GPLANET-"]').forEach(function (s) {
      reveal(s.querySelector('.gpl__hero-content'), 'up', 0);
      reveal(s.querySelector('.gpl__features'), 'up', 120);
      reveal(s.querySelector('.gpl__cols'), 'up', 160);
    });

    /* Gemstone Five Truths */
    document.querySelectorAll('[id^="GFT-"]').forEach(function (s) {
      reveal(s.querySelector('.gft__mobile-hd'), 'up', 0);
      reveal(s.querySelector('.gft__wrap'), 'up', 80);
    });

    /* Gemstone Promise */
    document.querySelectorAll('[id^="GP-"]').forEach(function (s) {
      reveal(s.querySelector('.gp__card'), 'scale', 0);
      revealAll(s.querySelectorAll('.gp__icon-item'), 'up', 120, 75);
    });

    /* Consultation (image-with-text) */
    document.querySelectorAll('.gems-consult').forEach(function (s) {
      reveal(s.querySelector('.gems-consult-content'), 'left', 0);
      /* Find the image block — it is a sibling of gems-consult-content */
      var textBlock = s.querySelector('.gems-consult-content');
      if (textBlock) {
        var imgBlock = textBlock.parentElement
          ? Array.prototype.find.call(
              textBlock.parentElement.children,
              function (c) { return !c.contains(textBlock); }
            )
          : null;
        if (!imgBlock) imgBlock = s.querySelector('img');
        if (imgBlock) reveal(imgBlock, 'right', 130);
      }
    });

    /* Calc Banner */
    document.querySelectorAll('[id^="gcb-"]').forEach(function (s) {
      reveal(s.querySelector('.gcb__card'), 'scale', 0);
    });

    /* Testimonials */
    document.querySelectorAll('[id^="GT-"]').forEach(function (s) {
      reveal(s.querySelector('.gt__heading'), 'up', 0);
      reveal(s.querySelector('.gt__slider'), 'up', 140);
    });

    /* Products */
    document.querySelectorAll('[id^="GPRODS-"]').forEach(function (s) {
      reveal(s.querySelector('.gprods__heading'), 'up', 0);
      revealAll(s.querySelectorAll('.gprods__item'), 'up', 80, 55);
    });

    /* ── Collection page ──────────────────────────────────────── */
    document.querySelectorAll('[id^="GColl-"]').forEach(function (s) {
      reveal(s.querySelector('.gc-sidebar'), 'left', 0);
      reveal(s.querySelector('.gc-toolbar'), 'up', 60);
      revealAll(s.querySelectorAll('.gc-card'), 'up', 80, 45);
    });

    /* ── PDP — sections below the main product block ─────────── */

    /* Product Reason Block */
    document.querySelectorAll('.product-reason-section').forEach(function (s) {
      reveal(s.querySelector('h2, h3, .section-heading'), 'up', 0);
      revealAll(s.querySelectorAll('[class*="reason-item"], [class*="card"], [class*="col"], li'), 'up', 80, 60);
    });

    /* How to Wear */
    document.querySelectorAll('.htw_img-content').forEach(function (s) {
      reveal(s, 'up', 0);
    });

    /* Benefits (img + text) */
    document.querySelectorAll('.benefits-section').forEach(function (s) {
      reveal(s.querySelector('h2, h3, .benefits-heading'), 'up', 0);
      revealAll(s.querySelectorAll('[class*="benefit-item"], [class*="benefit-card"], li'), 'up', 80, 55);
    });

    /* Who Can Wear */
    document.querySelectorAll('.wear-reason-section').forEach(function (s) {
      reveal(s.querySelector('h2, h3'), 'up', 0);
      revealAll(s.querySelectorAll('[class*="wear-item"], [class*="card"], li'), 'up', 80, 55);
    });

    /* Lead / Contact Form */
    document.querySelectorAll('.form-section').forEach(function (s) {
      reveal(s, 'scale', 0);
    });

    /* Product Recommendations */
    document.querySelectorAll('.product-recommendations').forEach(function (s) {
      reveal(s.querySelector('h2, h3'), 'up', 0);
      revealAll(s.querySelectorAll('[class*="product-card"], [class*="card-item"], li, .grid__item'), 'up', 80, 55);
    });

    /* ── Gemstone Calculator ─────────────────────────────────── */
    document.querySelectorAll('.gc-page-head').forEach(function (el) {
      reveal(el, 'up', 0);
    });
    document.querySelectorAll('.gc-form-card').forEach(function (el) {
      reveal(el, 'left', 80);
    });
    document.querySelectorAll('.gc-planets-card').forEach(function (el) {
      reveal(el, 'right', 80);
      revealAll(el.querySelectorAll('.gc-planet-cell'), 'up', 140, 50);
    });

    /* ── Generic fallback — any section not already handled ───── */
    document.querySelectorAll('.shopify-section').forEach(function (wrap) {
      if (wrap.querySelector('.gp-reveal')) return;
      if (wrap.querySelector('.gem-page')) return; // skip blog article sections
      var inner = wrap.firstElementChild;
      if (inner) reveal(inner, 'up', 0);
    });
  }

  /* ─── 2. IntersectionObserver ───────────────────────────────── */
  function observe() {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('gp-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.gp-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ─── 3. Background parallax ────────────────────────────────── */
  function initParallax() {
    var items = [];

    /* Hero slide images — subtle depth effect */
    document.querySelectorAll('.gemstone-hero .gh-slide__img--desktop').forEach(function (img) {
      img.classList.add('gp-parallax-bg');
      items.push({ el: img, wrap: img.closest('.gemstone-hero'), speed: 0.10 });
    });

    if (!items.length) return;

    var ticking = false;
    var vh = window.innerHeight;

    function update() {
      vh = window.innerHeight;
      items.forEach(function (item) {
        if (!item.wrap) return;
        var rect = item.wrap.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > vh + 80) return;
        var progress = 1 - (rect.top + rect.height) / (vh + rect.height);
        var offset = (progress - 0.5) * rect.height * item.speed;
        item.el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ─── Init ──────────────────────────────────────────────────── */
  function init() {
    tag();
    observe();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestAnimationFrame(init);
  }
})();
